import {fromJS, Map} from 'immutable';
import performanceActions from '../../actions/fortnite-game/performance.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TimeScale, Version} from '../../types';

interface ListItem {
    [key: number]: number;
    time: string;
}

export interface PerformanceState {
    data: {
        [TimeScale.HOURLY]: ListItem[];
        [TimeScale.DAILY]: ListItem[];
    };
    versions: Version[];
    wau: number;
    loading: boolean;
    lastFetch: Date;
    error?: string;
}

const DEFAULT_DATA = {
    [TimeScale.HOURLY]: [],
    [TimeScale.DAILY]: []
};

export const DEFAULT_STATE = fromJS({
    data: DEFAULT_DATA,
    versions: [],
    wau: 0,
    timeScale: TimeScale.DAILY,
    lastFetch: Date.now(),
    loading: false,
    error: undefined
});

export const performanceReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timescale, data, versions, wau, silent = false, error} = action.payload || {};

    switch (action.type) {
        case performanceActions.TYPES.GET_PERFORMANCE: {
            return state.merge({
                timeScale: timescale,
                error: undefined,
                loading: !silent
            });
        }

        case performanceActions.TYPES.GET_PERFORMANCE_COMPLETE: {
            return state
                .update('data', stateData => stateData.set(state.get('timeScale'), data))
                .merge({
                    versions,
                    wau,
                    lastFetch: Date.now(),
                    loading: false,
                    error
                });
        }

        case performanceActions.TYPES.GET_PERFORMANCE_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('performance', performanceReducer);
